export function currencyToNumber(currency: string) {
  if(typeof currency != "string") {
    return;
  }
  return Number(currency.replace('R$', '').replace(',', '.').split(' ').join(''))
}